import { useCallback, useEffect, useRef, useState } from "react"
import { getNearbyMembers } from "../../services/membersService";
import { NearbyMemberModel } from "./models/NearbyMemberModel";

export const useNearbyMembers = (search?: string) => {
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState<NearbyMemberModel[]>([]);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);
    

    const load = useCallback(async () => {
        if(!search || loading)
            return;
        try {
            setLoading(true);
            const _result = await getNearbyMembers(search);
            if(!isMountedRef.current)
                return;
            if(_result.results)
                setList(_result.results);            
        }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }, [search]);

    useEffect(() => {
        load();
    }, [load]);

    return { loading, list }
}